module.exports = function(item, view){
	var config = view.$getConfig();

	return {
		top: view.getItemTop(item.id),
		height: config.row_height,
		left: 0,
		right: Infinity
	};
};